'use client';

import { MDXError } from './mdx-error';

type MDXScriptProps = React.HTMLAttributes<HTMLScriptElement> & {
  hasProPlus: boolean;
};

export function MDXScript({ hasProPlus, children, ...props }: MDXScriptProps) {
  if (!hasProPlus) {
    return (
      <MDXError
        title="Pro+ Plan Required"
        description={
          <>
            Please upgrade your account to use script tags if you manage this
            site.
          </>
        }
        cta={{
          label: 'Upgrade',
          href: 'https://app.quotion.co/billing',
        }}
      />
    );
  }
  return (
    <script
      {...props}
      dangerouslySetInnerHTML={{ __html: children as string }}
    />
  );
}
